// LoaderOverlay.js
export default function LoaderOverlay({ show, progress, status }) {
    if (!show) return null;

    return (
        <div className="loader-overlay">
            <div className="loader-box">
                <div className="spinner" />

                <p className="loader-text">
                    {status !== "completed" ? (
                        <>
                            Uploading in Progress...{" "}
                        </>
                    ) : (
                        "Completed"
                    )}
                </p>
            </div>
        </div>
    );
}